module.exports = __webpack_public_path__ + "img/trust_icon.638e9569.svg";